<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: "app",
  components: {
  },
  data() {
    return {};
  },
  watch: {
   
  },
  mounted() {

  },
  computed: {
    showBottom() {
      return (this.$route.meta || {}).showBottom;
    },
    activeTab() {
      let name = (this.$route.meta || {}).bottomName;
      if (!name) {
        name = (this.$route || {}).name;
      }
      return name;
    }
  }
};
</script>

<style>

.show-home-btn {
  background-image: linear-gradient(
    -90deg,
    rgb(81, 163, 249) 0%,
    rgb(50, 131, 254) 100%
  );
  width: 80%;
  color: white;
  margin: 0 auto;
  display: block;
  border-radius: 4px;
  border: 0;
  font-size: 14px;
  padding: 10px 0;
  text-align: center;
}
body {
  font-size: 16px;
  background-color: white;
  -webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
  font-family: "Arial","Microsoft YaHei","黑体","宋体",sans-serif;
}
.content-box {
  /*padding-bottom: 56px;*/
  width: 100%;
  height: 100%;
}
.bottom {
  position: fixed;
  width: 100%;
  height: 65px;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0 1px 12px #ebedf0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-size: 11px;
  color: #333;
}
.bottom > div {
  width: 92px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}


</style>
